// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "ddc30334571f5d86e163575234a68c63f8f1e65b",
  version: "1.132.0",
};
